import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { supabase } from "@/integrations/supabase/client";

/**
 * Picks a RANDOM published lesson on every page load / session.
 * The randomness seed is generated once per mount, so the same lesson
 * stays for the lifetime of the page but rotates on refresh / login.
 */
export const useFeaturedLesson = () => {
  // New seed on every mount → re-randomized on each visit / login.
  const seed = useMemo(() => Math.random().toString(36).slice(2), []);

  return useQuery({
    queryKey: ["featured-lesson", seed],
    staleTime: Infinity,
    queryFn: async () => {
      const { data: lessons, error } = await supabase
        .from("lessons")
        .select("id, title, description, duration, price, regular_price, cover_url, available_until")
        .eq("is_published", true);


      if (error) throw error;
      if (!lessons || lessons.length === 0) return null;

      const pick = lessons[Math.floor(Math.random() * lessons.length)];
      return pick;
    },
  });
};
